
import { i18nText } from '@/locales';
import { RouterNameEnum } from "@/router/router.types";
export { tabs }

const tabs = [
    {
        id: RouterNameEnum.ClientDetailCommon,
        aliases: [],
        name: i18nText("Общее")
    },
    {
        id: RouterNameEnum.ClientDetailNotesPage,
        aliases: [],
        name: i18nText("Записи")
    },
    {
        id: RouterNameEnum.ClientDetailHistoryPage,
        aliases: [],
        name: i18nText("История посещений")
    },
    /*{
        id: RouterNameEnum.ClientDetailTasksPage,
        name: 'Задачи'
    },
    {
        id: RouterNameEnum.ClientDetailDocumentsPage,
        name: 'Документы'
    },
    {
        id: RouterNameEnum.ClientDetailPhotoPage,
        name: 'Фото'
    },
    {
        id: RouterNameEnum.ClientDetailContraindicationsPage,
        name: 'Противопоказания'
    },*/
    {
        id: RouterNameEnum.ClientDetailLoyaltyPage,
        aliases: [RouterNameEnum.ClientDetailLoyaltyPage.toString(), RouterNameEnum.clientsDetailLoyaltyCertificates.toString()],
        name: i18nText("Лояльность")
    },
    {
        id: RouterNameEnum.ClientDetailAccountsPage,
        aliases: [],
        name: i18nText("Счет клиента")
    }
];
